// LIBS
import { Component, inject, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DSM3NavItem } from '@eredes/dsm3';
import { DSM34Dialog } from '@eredes/dsm34';
import { ExcelService } from '@eredes/microservices';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';
import { saveAs } from 'file-saver';
import moment from 'moment';
import { Observable, concat, Subject, BehaviorSubject } from 'rxjs';

// MODELS
import { RequestPermission } from '../../_core/models/request-permission.model';
import { RetailerModel } from '../../_core/models/retailer.model';

// COMPONENTS
import { GlobalService } from '../../_core/services/global.service';
import { RetailerService } from '../../_core/services/retailer.service';
import { UserService } from '../../_core/services/user.service';
import { datePickerOptionsData } from '../../_shared/edp-datepicker/edp-datepicker-options.data';
import { EdpTableComponent } from '../../_shared/edp-table/edp-table.component';
import { EdpTableInterface } from '../../_shared/edp-table/edp-table.interface';
import { GenericModalComponent } from '../../_shared/generic-modal/generic-modal.component';
import { Directory } from '../../_shared/tree/directory';

// SERVICES
import { AuthService } from '../../auth/auth.service';
import { RequestStatusModel } from '../models/request-status.model';
import { RequestTypeModel } from '../models/request-type.model';
import { RequestFolder } from '../request-list/request-folder.helper';
import { RequestPermissionService } from '../request-permission.service';
import { RequestService } from '../request.service';

// Helpers
import { RequestListMapExcel } from './request-list-map-excel.helper';

import { EdpResponseBody } from 'app/_core/models/edp-response.model';
import { UserModel } from 'app/_core/models/user.model';
import { GoogleAnalyticsEventsService } from 'app/_core/services/google-analytics-events.service';

@Component({
  selector: 'app-request-list-old',
  templateUrl: './request-list-old.component.html',
  styleUrls: ['./request-list-old.component.scss'],
  standalone: false,
})
export class RequestListOldComponent extends EdpTableComponent implements OnInit, EdpTableInterface {
  breadcrumbsItems$: Subject<DSM3NavItem[]> = new BehaviorSubject<DSM3NavItem[]>([]);

  breadcrumbTitle: string;

  user: UserModel;
  userProfile: any;
  menuList: Directory[];
  isEmptyList: boolean;
  isRet: boolean;
  isMngtNotRet: boolean;
  retailersList: RetailerModel[];
  selectRetailer: any = 'pt.edp.retailer.0';
  dataGenericModal: any;
  requestSession: any;

  searchPlaceholder = 'Pesquise por CPE, ID ou Criado por';

  requestOperationType: string;
  requestTitle: string;
  requestType: string;
  permissions: string[] = [];
  requestOperation = 'pt.edp.request.operation.1';
  endedStatus = ['pt.edp.request.status.3', 'pt.edp.request.status.4'];

  requestStatusData: RequestStatusModel[];
  requestStatusSelected: string;
  countRequestStatusSelected = 0;

  requestOperationData: RequestTypeModel[];
  requestAreaData: RequestTypeModel[];
  requestType1Data: RequestTypeModel[];
  requestType2Data: RequestTypeModel[];

  requestOperationRetSelected: string;
  requestOperationSelected: string;
  requestOperationTitleSelected: string;
  requestOperationCheckPo = false;
  requestOperationCheckPe = false;
  requestAreaSelected: string;
  requestAreaTitleSelected: string;
  requestType1Selected: string;
  requestType1TitleSelected: string;
  requestType2Selected: string;
  requestType2TitleSelected: string;
  showAllFilters = false;

  requestFolders: any[];
  requestFolderUniqueCode: string;
  assignableUsers: any[];

  order = 'createdAt';
  direction = 'DESC';

  lookFor: any = '';

  rPermission: RequestPermission;
  requestStatusSelectedWhenOpenedDropdown: RequestStatusModel[] = [];
  @ViewChild('statusDropdown') statusDropdown: NgbDropdown;
  isRequestingData = false;

  // CURRENT PAGE
  currentRequestPage: number;
  showSessionFilters = false;
  count = 0;

  invalidDateInterval = false;
  invalidToBiggerThanFrom = false;
  requestDateForm: UntypedFormGroup;
  filtersCtrl = false;

  public dialog = inject(DSM34Dialog);

  get f() {
    return this.requestDateForm.controls;
  }

  constructor(
    protected userService: UserService,
    public authService: AuthService,
    protected globalService: GlobalService,
    protected requestService: RequestService,
    protected retailerService: RetailerService,
    protected router: Router,
    protected route: ActivatedRoute,
    protected requestPermissionService: RequestPermissionService,
    private readonly fb: UntypedFormBuilder
  ) {
    super(userService, authService, globalService);
  }

  private setBreadcrumb(): void {
    const breadcrumbsItems: DSM3NavItem[] = [
      {
        label: 'Pedidos',
        href: '/request',
      },
      {
        label: `${this.breadcrumbTitle}`,
        href: this.getRouteBreadcrumb(),
      },
    ];
    this.breadcrumbsItems$.next(breadcrumbsItems);
  }

  private getRouteBreadcrumb() {
    if (!this.isRet) {
      return '/request/request-edp';
    } else if (this.requestOperationType === 'pt.edp.request.operation.1') {
      return '/request/request-operation';
    } else if (this.requestOperationType === 'pt.edp.request.operation.2') {
      return '/request/request-clarification';
    }
  }

  ngOnInit() {
    this.datePickerOptions = datePickerOptionsData;
    this.currentRequestPage = 0;
    super.ngOnInit();
    this.user = this.userService.getUser();
    this.isRet = this.userService.isProfileRetailer();
    this.isMngtNotRet = this.userService.isInternalMngt();
    if (!this.isRet) {
      this.getRetailers();
      this.searchPlaceholder = 'Pesquise por CPE, ID ou Atribuído a';
    }

    this.resetDataFilters();
    this.resetSelectedFilters();

    this.route.data.subscribe((data) => {
      this.requestType = data.requestType;
      this.requestOperationType = data.requestOperationType || '';
      this.requestOperationRetSelected = data.requestOperationType || '';
      this.requestTitle = data.requestTitle || '';
      this.breadcrumbTitle = this.requestTitle || 'Listagem';

      if (data.requestOperationType === this.requestOperation) {
        this.requestPermissionService.getCreatePoPermissions().subscribe((permissionData) => {
          this.permissions = permissionData || [];
          this.rPermission = new RequestPermission(this.permissions, true, false, true, true, false);
        });
      } else {
        this.requestPermissionService.getCreatePePermissions().subscribe((permissionData) => {
          this.permissions = permissionData || [];
          this.rPermission = new RequestPermission(this.permissions, true, false, true, true, false);
        });
      }
      this.setBreadcrumb();
    });
    this.initForm();
    this.isRequestingData = true;
    this.requestService.getInitialData(this.isRet).subscribe(
      (data: any) => {
        this.requestSession = sessionStorage.getItem('savedFilters');
        if (!this.isRet) {
          this.requestFolders = data[1].Result.Collection;
          this.menuList = new RequestFolder().mapFolders(this.requestFolders);
        }
        if (this.requestSession) {
          this.showSessionFilters = true;
          this.applyFilters();
        } else {
          this.refreshData(0);
          this.initStatusData(data[0]);
        }
      },
      (err: any) => {
        console.error(err);
        this.resetDataFilters();
        this.isRequestingData = false;
      }
    );
    if (!this.isRet) {
      GoogleAnalyticsEventsService.emitEvent(
        'Pedidos',
        'Listagem de Pedidos E-REDES',
        'Visualiza listagem de Pedidos E-REDES'
      );
    } else if (this.requestOperationType === 'pt.edp.request.operation.1') {
      GoogleAnalyticsEventsService.emitEvent(
        'Pedidos',
        'Listagem de Pedidos de Operação',
        'Visualiza listagem de Pedido de Operação'
      );
    } else if (this.requestOperationType === 'pt.edp.request.operation.2') {
      GoogleAnalyticsEventsService.emitEvent(
        'Pedidos',
        'Listagem de Pedidos de Esclarecimento',
        'Visualiza listagem de Pedido de Esclarecimento'
      );
    }
  }

  private initForm(): void {
    this.requestDateForm = this.fb.group({
      dateStart: new UntypedFormControl(null, []),
      dateEnd: new UntypedFormControl(null, []),
    });
    this.onChanges();
  }

  private onChanges(): void {
    this.requestDateForm.get('dateStart').valueChanges.subscribe((val) => {
      if (val !== null) {
        this.checkDates();
      }
    });
    this.requestDateForm.get('dateEnd').valueChanges.subscribe((val) => {
      if (val !== null) {
        this.checkDates();
      }
    });
    this.requestDateForm.valueChanges.subscribe((val) => {
      if (val.dateStart !== null || val.dateEnd !== null) {
        this.checkDates();
      } else {
        this.invalidDateInterval = false;
        if (
          this.requestStatusSelected ||
          this.requestAreaSelected ||
          this.requestType1Selected ||
          this.requestType2TitleSelected ||
          this.searchTerm
        ) {
          this.filtersCtrl = true;
        }
      }
    });
    this.requestDateForm.updateValueAndValidity();
  }

  /**
   * Validate dates range
   */
  private checkDates(): void {
    const dateFrom = this.requestDateForm.get('dateStart').value;
    const dateTo = this.requestDateForm.get('dateEnd').value;

    if (dateFrom !== null && dateTo !== null) {
      const from = dateFrom ? moment(dateFrom) : null;
      const to = dateTo ? moment(dateTo) : null;
      this.invalidDateInterval = from !== null && to !== null ? false : true;
      this.invalidToBiggerThanFrom = moment(to).isSameOrBefore(from);
    } else {
      this.invalidToBiggerThanFrom = false;
      this.invalidDateInterval = true;
    }

    this.filtersCtrl = !this.invalidDateInterval && !this.invalidToBiggerThanFrom;
  }

  /**
   * Setup the requests status filters
   * @param response with the data
   */
  initStatusData(response: EdpResponseBody): void {
    this.requestStatusData = response.Result.Collection;
    this.isRequestingData = false;
    this.countRequestStatusSelected = 0;
  }

  resetDataFilters() {
    this.requestAreaData = [];
    this.requestType1Data = [];
    this.requestType2Data = [];
    this.requestStatusData = [];
    this.requestOperationSelected = '';
    this.requestOperationTitleSelected = '';
  }

  resetSelectedFilters() {
    this.requestStatusSelected = '';
    this.countRequestStatusSelected = 0;
    this.requestType1Selected = '';
    this.requestType1TitleSelected = '';
    this.requestType2Selected = '';
    this.requestType2TitleSelected = '';
  }

  // EXPORT EXCEL REQUEST
  export() {
    this.refreshData(0, null, true);
  }

  refreshData(skip: number, order?: string, excelExport = false) {
    this.isRequestingData = true;

    if (this.count === 0) {
      this.count++;
    } else {
      this.setFilters();
    }

    const data = sessionStorage.getItem('savedFilters');
    this.showSessionFilters = data && data.length > 0 ? true : false;

    if (order) {
      if (order !== this.order) {
        this.direction = 'DESC';
      } else {
        this.direction = this.direction === 'ASC' ? 'DESC' : 'ASC';
      }
    } else {
      order = this.order;
    }

    this.order = order;

    const args: any = {
      entity: 'Request',
      retailerUniqueCode: this.userService.getRetailerUniqueCode(),
      skip: skip,
      top: this.top,
      orderby: this.order + ' ' + this.direction,
    };

    const reportArgs: any = {
      entity: 'Request',
      retailerUniqueCode: this.userService.getRetailerUniqueCode(),
      orderby: 'createdAt DESC, requestTransactionDate ASC',
    };

    if (this.requestFolderUniqueCode) {
      args.requestFolderUniqueCode = this.requestFolderUniqueCode;
      reportArgs.requestFolderUniqueCode = this.requestFolderUniqueCode;
    }

    if (this.selectRetailer && this.showRetailerList()) {
      args.retailerUniqueCode = this.selectRetailer;
      reportArgs.retailerUniqueCode = this.selectRetailer;
    }

    // FILTER BY DATE
    if (this.requestDateForm.get('dateStart') && this.requestDateForm.get('dateStart').value) {
      args.dateStart = moment(this.requestDateForm.get('dateStart').value)
        .set({ hour: 0, minute: 0, second: 0 })
        .local()
        .format('YYYY-MM-DD HH:mm:ss');
      reportArgs.dateStart = args.dateStart;
    }

    if (this.requestDateForm.get('dateEnd') && this.requestDateForm.get('dateEnd').value) {
      args.dateEnd = moment(this.requestDateForm.get('dateEnd').value)
        .set({ hour: 23, minute: 59, second: 59 })
        .local()
        .format('YYYY-MM-DD HH:mm:ss');
      reportArgs.dateEnd = args.dateEnd;
    }

    // FILTER BY STATUS
    const requestStates = [];
    for (let i = 0; i < this.requestStatusData.length; i++) {
      if (this.requestStatusData[i].requestStatusSelected) {
        requestStates.push(this.requestStatusData[i].requestStatusUniqueCode);
      }
    }

    if (requestStates.length > 0 && requestStates.length < this.requestStatusData.length) {
      reportArgs.requestStates = requestStates.join(' ');
      args.requestStates = reportArgs.requestStates;

      if (reportArgs.requestStates.indexOf('pt.edp.request.status.EDP') >= 0) {
        reportArgs.requestStates = reportArgs.requestStates.replace(
          'pt.edp.request.status.EDP',
          'pt.edp.request.status.1 pt.edp.request.status.2 pt.edp.request.status.6'
        );
        args.requestStates = reportArgs.requestStates;
      }
    }

    // FILTER BY OPERATION RET
    if (this.requestOperationRetSelected) {
      args.requestOperationType = this.requestOperationType;
    }

    // FILTER BY OPERATION ORD
    if (this.requestOperationSelected) {
      args.requestOperationType = this.requestOperationSelected;
      reportArgs.requestOperationType = this.requestOperationSelected;
    }

    // FILTER BY AREA
    if (this.requestAreaSelected) {
      args.requestOperationArea = this.requestAreaSelected;
      reportArgs.requestOperationArea = this.requestAreaSelected;
    }

    // FILTER BY TYPE1
    if (this.requestType1Selected) {
      args.requestOperationType1 = this.requestType1Selected;
      reportArgs.requestOperationType1 = this.requestType1Selected;
    }

    // FILTER BY TYPE2
    if (this.requestType2Selected) {
      args.requestOperationType2 = this.requestType2Selected;
      reportArgs.requestOperationType2 = this.requestType2Selected;
    }

    // Open Search
    if (this.searchTerm) {
      args.searchTerm = this.searchTerm;
      reportArgs.searchTerm = this.searchTerm;
    }

    if (excelExport) {
      reportArgs.skip = 0;
      reportArgs.top = 1;

      if (this.isRet) {
        reportArgs.requestOperationType = this.requestOperationType;
      }

      this.globalService
        .callServicePost('pt.edp.comercializadores.request.getReports', reportArgs, {})
        .subscribe((getTotal) => {
          const itemsByPage = 1000;
          const totalPages = Math.ceil(getTotal.Result.TotalCount / itemsByPage);

          const calls$ = new Array<Observable<any>>();
          for (let i = 0; i !== totalPages; ++i) {
            reportArgs.skip = i * itemsByPage;
            reportArgs.top = itemsByPage;
            calls$.push(
              this.globalService.callServicePost(
                'pt.edp.comercializadores.request.getReports',
                Object.assign({}, reportArgs),
                {}
              )
            );
          }

          const dataToExport = [];
          concat(...calls$).subscribe(
            (res: EdpResponseBody) => {
              dataToExport.push(...res.Result.Collection);
            },
            (error) => {
              this.dataGenericModal = {
                modalTitle: 'Atenção',
                modalText: 'Ocorreu um erro na operação. Tente novamente.',
                btnConfirmText: 'OK',
                error: true,
              };
              this.openGenericDialog(GenericModalComponent);
            },
            () => {
              const filteredData = RequestListMapExcel.mapExcel(dataToExport, this.isRet);
              ExcelService.createFile({
                exportData: filteredData,
                prefixFileName: 'Pedidos_',
                sheetName: 'Pedidos',
              }).then(({ blob, filename }) => saveAs(blob, filename));
            }
          );
        });
    } else {
      this.globalService.callServicePost('pt.edp.comercializadores.request.getHandle', args, {}).subscribe(
        (result: any) => {
          const requests = result.Result.Collection.requests;
          this.tableData = requests.Collection;
          this.assignableUsers = result.Result.Collection.assignableUsers.Collection;
          this.uncheckAll();
          this.skip = requests.Skip;
          this.totalItems = requests.TotalCount;
          this.isEmptyList = this.totalItems > 0 ? false : true;

          this.currentRequestPage = 0;

          if (this.skip !== 0) {
            this.currentRequestPage = this.skip / this.top;
          }

          if (this.isRet) {
            this.requestOperationRetSelected = this.requestOperationType;
          } else {
            this.requestOperationSelected = this.requestOperationSelected || '';
          }

          this.checkFilterApplied();
          this.isRequestingData = false;
        },
        (err) => {
          console.error(err);
          this.tableData = [];
          this.isRequestingData = false;
        }
      );
    }
  }

  statusDropdownClick(isOpen) {
    if (isOpen) {
      this.requestStatusSelectedWhenOpenedDropdown = [];
      for (let i = 0; i < this.requestStatusData.length; i++) {
        this.requestStatusSelectedWhenOpenedDropdown.push(Object.assign({}, this.requestStatusData[i]));
      }
    } else {
      setTimeout(() => {
        if (!this.isRequestingData) {
          for (let i = 0; i < this.requestStatusData.length; i++) {
            for (let j = 0; j < this.requestStatusSelectedWhenOpenedDropdown.length; j++) {
              if (
                this.requestStatusData[i].requestStatusUniqueCode ===
                this.requestStatusSelectedWhenOpenedDropdown[j].requestStatusUniqueCode
              ) {
                this.requestStatusData[i].requestStatusSelected =
                  this.requestStatusSelectedWhenOpenedDropdown[j].requestStatusSelected;
              }
            }
          }
          this.countAllRequestStatusSelected();
        }
      }, 250);
    }
  }

  // FILTER FUNCTIONS
  checkFilterApplied() {
    if (this.requestAreaSelected && this.requestType1Selected && this.requestType2Selected) {
      this.filtersCtrl = true;
      this.showSessionFilters = true;
    } else if (this.requestAreaSelected && this.requestType1Selected) {
      this.initType2List(this.requestType1Selected);
    } else if (this.requestAreaSelected) {
      this.initType1List(this.requestAreaSelected);
    } else {
      this.requestOperationRetSelected
        ? this.initAreaList(this.requestOperationRetSelected)
        : this.initAreaList(this.requestOperationSelected);
    }
  }

  // AREA LIST
  initAreaList(info) {
    this.requestAreaData = [];
    this.requestType1Data = [];
    this.requestType2Data = [];
    this.requestAreaSelected = '';
    this.requestAreaTitleSelected = '';
    this.requestType1Selected = '';
    this.requestType1TitleSelected = '';
    this.requestType2Selected = '';
    this.requestType2TitleSelected = '';
    this.requestService.getOperationChildren(info).subscribe(
      (data: any) => {
        this.requestAreaData = data.Result.Collection;
      },
      (err: any) => {
        console.error(err);
      }
    );
  }

  // TYPE 1 LIST
  initType1List(info) {
    this.requestType1Data = [];
    this.requestType2Data = [];
    this.requestType1Selected = '';
    this.requestType1TitleSelected = '';
    this.requestType2Selected = '';
    this.requestType2TitleSelected = '';
    this.requestService.getOperationChildren(info).subscribe(
      (data: any) => {
        this.requestType1Data = data.Result.Collection;
      },
      (err: any) => {
        console.error(err);
      }
    );
  }

  // TYPE 2 LIST
  initType2List(info) {
    this.requestType2Data = [];
    this.requestType2Selected = '';
    this.requestType2TitleSelected = '';
    this.requestService.getOperationChildren(info).subscribe(
      (data: any) => {
        this.requestType2Data = data.Result.Collection;
      },
      (err: any) => {
        console.error(err);
      }
    );
  }

  itemRequestOperationSelected(item) {
    this.filtersCtrl = true;
    if (item === 'po') {
      this.requestOperationSelected = 'pt.edp.request.operation.1';
      this.requestOperationTitleSelected = 'Pedido de operação';
      this.requestOperationCheckPo = true;
      this.requestOperationCheckPe = false;
    } else if (item === 'pe') {
      this.requestOperationSelected = 'pt.edp.request.operation.2';
      this.requestOperationTitleSelected = 'Pedido de esclarecimento';
      this.requestOperationCheckPo = false;
      this.requestOperationCheckPe = true;
    } else {
      return false;
    }
    this.initAreaList(this.requestOperationSelected);
  }

  itemRequestAreaSelected(index: number) {
    for (let i = 0; i < this.requestAreaData.length; i++) {
      this.requestAreaData[index].requestOperationSelected = false;
    }
    this.filtersCtrl = true;
    this.requestAreaData[index].requestOperationSelected = true;
    this.requestAreaSelected = this.requestAreaData[index].requestOperationUniqueCode;
    this.requestAreaTitleSelected = this.requestAreaData[index].requestOperationTitle;
    this.initType1List(this.requestAreaData[index].requestOperationUniqueCode);
  }

  itemRequestType1Selected(index: number) {
    for (let i = 0; i < this.requestType1Data.length; i++) {
      this.requestType1Data[index].requestOperationSelected = false;
    }
    this.requestType1Data[index].requestOperationSelected = true;
    this.requestType1Selected = this.requestType1Data[index].requestOperationUniqueCode;
    this.requestType1TitleSelected = this.requestType1Data[index].requestOperationTitle;
    this.initType2List(this.requestType1Data[index].requestOperationUniqueCode);
  }

  itemRequestType2Selected(index: number) {
    for (let i = 0; i < this.requestType2Data.length; i++) {
      this.requestType2Data[index].requestOperationSelected = false;
    }
    this.requestType2Data[index].requestOperationSelected = true;
    this.requestType2Selected = this.requestType2Data[index].requestOperationUniqueCode;
    this.requestType2TitleSelected = this.requestType2Data[index].requestOperationTitle;
  }

  removeTypeFilter(item) {
    if (item === this.requestAreaSelected) {
      for (let i = 0; i < this.requestAreaData.length; i++) {
        this.requestAreaData[i].requestOperationSelected = false;
      }
      this.requestAreaSelected = '';
      this.requestAreaTitleSelected = '';
      this.requestType1Data = [];
      this.requestType2Data = [];
    } else if (item === this.requestType1Selected) {
      for (let i = 0; i < this.requestType1Data.length; i++) {
        this.requestType1Data[i].requestOperationSelected = false;
      }
      this.requestType1Selected = '';
      this.requestType1TitleSelected = '';
      this.requestType2Data = [];
    } else if (item === this.requestType2Selected) {
      for (let i = 0; i < this.requestType2Data.length; i++) {
        this.requestType2Data[i].requestOperationSelected = false;
      }
      this.requestType2Selected = '';
      this.requestType2TitleSelected = '';
    } else {
      this.requestOperationSelected = '';
      this.requestOperationTitleSelected = '';
      this.requestAreaSelected = '';
      this.requestAreaTitleSelected = '';
      this.requestType1Selected = '';
      this.requestType1TitleSelected = '';
      this.requestType2Selected = '';
      this.requestType2TitleSelected = '';
      this.requestOperationCheckPo = false;
      this.requestOperationCheckPe = false;
      this.requestAreaData = [];
      this.requestType1Data = [];
      this.requestType2Data = [];
    }
    this.refreshData(0);
  }

  // STATUS COUNT
  countAllRequestStatusSelected() {
    this.countRequestStatusSelected = 0;
    const arraySelected = [];
    for (let i = 0; i < this.requestStatusData.length; i++) {
      if (this.requestStatusData[i].requestStatusSelected) {
        arraySelected.push(this.requestStatusData[i].requestStatusUniqueCode);
        this.countRequestStatusSelected++;
      }
    }
    this.requestStatusSelected = arraySelected.join(' ');
    this.filtersCtrl = true;
  }

  toggleCheckRequestStatus(index: number) {
    this.requestStatusData[index].requestStatusSelected = !this.requestStatusData[index].requestStatusSelected;
    this.countAllRequestStatusSelected();
  }
  // END FILTER FUNCTIONS

  openNewOperationRequest() {
    this.setFilters();
    this.router.navigate(['request-create'], { relativeTo: this.route });
  }

  setFolder(requestFolderUniqueCode: string, skip?: number) {
    this.requestFolderUniqueCode = requestFolderUniqueCode;
    if (skip) {
      this.refreshData(skip);
    } else {
      this.refreshData(0);
    }
  }

  getStatusMap(item) {
    if (this.isRet && item.requestStatusUniqueCode === 'pt.edp.request.status.2') {
      return 'Submetido';
    }

    return item.requestStatus;
  }

  getRetailers() {
    this.retailerService.getRetailers().subscribe((retailers) => (this.retailersList = retailers));
  }

  changeRetailer() {
    this.refreshData(0);
  }

  showRetailerList() {
    return this.user.ord && this.user.ord.code === 'pt.edp.retailer.0' && !this.isRet;
  }

  openRequestDetail(uniqueCode: string) {
    this.setFilters();
    this.router.navigate(['request-detail', uniqueCode], { relativeTo: this.route });
  }

  public assignRequests(assignee?: string) {
    const selectedIds = [];
    this.tableData.forEach(function (obj) {
      if (obj.itemSelected === true) {
        selectedIds.push(obj.requestUniqueCode);
      }
    });

    this.requestService.assignTo(assignee, selectedIds).subscribe(
      (data) => {
        this.refreshData(this.skip);
        this.successAssignMessage();
      },
      (err) => {
        this.refreshData(this.skip);
        this.errorAssignMessage();
      }
    );
  }

  showCheck(request: any) {
    // is retailer
    if (this.isRet) {
      return false;
    }

    // request is ended
    if (this.endedStatus.indexOf(request.statusUniqueCode) !== -1) {
      return false;
    }

    // logged user is internalMngt
    if (this.userService.isInternalMngt()) {
      return true;
    }

    // assigned request is null or like logged user
    if (
      request.assignedUserUniqueCode === null ||
      this.userService.getUserUniqueCode() === request.assignedUserUniqueCode
    ) {
      return true;
    }

    return false;
  }

  // OPEN GENERIC MODAL
  openGenericDialog(component) {
    this.dialog.open(component, {
      data: this.dataGenericModal,
      disableClose: false,
    });
  }

  // ERROR MESSAGE GENERIC
  errorAssignMessage() {
    this.dataGenericModal = {
      modalTitle: 'Atenção',
      modalText: 'Ocorreu um erro na operação. Tente novamente.',
      btnConfirmText: 'OK',
      error: true,
    };
    this.openGenericDialog(GenericModalComponent);
  }

  // SUCCESS MESSAGE GENERIC
  successAssignMessage() {
    this.dataGenericModal = {
      modalTitle: 'Sucesso',
      modalText: 'Operação concluída.',
      btnConfirmText: 'Ok',
      success: true,
    };
    this.openGenericDialog(GenericModalComponent);
  }

  // SAVE FILTERS IN SESSION STORAGE TO APPLY IN URL
  setFilters() {
    const folder = this.requestFolderUniqueCode || '';
    const retailer = this.selectRetailer || this.user.retailerUniqueCode;
    const start = this.requestDateForm.get('dateStart').value;
    const end = this.requestDateForm.get('dateEnd').value;
    const status = this.requestStatusData;
    const operation = this.requestOperationRetSelected || this.requestOperationSelected;
    const area = this.requestAreaData;
    const type1 = this.requestType1Data;
    const type2 = this.requestType2Data;
    const search = this.searchTerm;
    const page = this.currentRequestPage;
    const savedFilters = {
      currentRequestFolder: folder,
      currentRequestFilterRetailer: retailer,
      currentRequestFilterStart: start,
      currentRequestFilterEnd: end,
      currentRequestFilterStatus: status,
      currentRequestFilterSearch: search,
      currentRequestFilterOperation: operation,
      currentRequestFilterArea: area,
      currentRequestFilterType1: type1,
      currentRequestFilterType2: type2,
      menuList: this.menuList,
      currentRequestPage: page,
    };
    sessionStorage.setItem('savedFilters', JSON.stringify(savedFilters));
  }

  applyFilters() {
    const data = sessionStorage.getItem('savedFilters');
    const allData = JSON.parse(data);

    const folder = allData.currentRequestFolder;
    const retailer = allData.currentRequestFilterRetailer;
    const start = allData.currentRequestFilterStart;
    const end = allData.currentRequestFilterEnd;
    const status = allData.currentRequestFilterStatus;
    const operation = allData.currentRequestFilterOperation;
    const area = allData.currentRequestFilterArea;
    const type1 = allData.currentRequestFilterType1;
    const type2 = allData.currentRequestFilterType2;
    const search = allData.currentRequestFilterSearch;
    const page = allData.currentRequestPage || 0;

    this.requestFolderUniqueCode = folder;
    this.selectRetailer = retailer;
    this.requestStatusData = status;
    this.countAllRequestStatusSelected();

    this.requestAreaData = area;
    this.requestType1Data = type1;
    this.requestType2Data = type2;
    this.searchTerm = search;

    if (operation) {
      if (operation === 'pt.edp.request.operation.1') {
        this.requestOperationSelected = 'pt.edp.request.operation.1';
        this.requestOperationTitleSelected = 'Pedido de operação';
        this.requestOperationCheckPo = true;
        this.requestOperationCheckPe = false;
      } else {
        this.requestOperationSelected = 'pt.edp.request.operation.2';
        this.requestOperationTitleSelected = 'Pedido de esclarecimento';
        this.requestOperationCheckPo = false;
        this.requestOperationCheckPe = true;
      }
      this.filtersCtrl = true;
    }

    if (area) {
      for (let i = 0; i < this.requestAreaData.length; i++) {
        if (this.requestAreaData[i].requestOperationSelected) {
          this.requestAreaSelected = this.requestAreaData[i].requestOperationUniqueCode;
          this.requestAreaTitleSelected = this.requestAreaData[i].requestOperationTitle;
        }
      }
    }

    if (type1) {
      for (let i = 0; i < this.requestType1Data.length; i++) {
        if (this.requestType1Data[i].requestOperationSelected) {
          this.requestType1Selected = this.requestType1Data[i].requestOperationUniqueCode;
          this.requestType1TitleSelected = this.requestType1Data[i].requestOperationTitle;
        }
      }
    }

    if (type2) {
      for (let i = 0; i < this.requestType2Data.length; i++) {
        if (this.requestType2Data[i].requestOperationSelected) {
          this.requestType2Selected = this.requestType2Data[i].requestOperationUniqueCode;
          this.requestType2TitleSelected = this.requestType2Data[i].requestOperationTitle;
        }
      }
    }

    if (start) {
      this.requestDateForm.get('dateStart').setValue(start);
    }

    if (end) {
      this.requestDateForm.get('dateEnd').setValue(end);
    }

    const current = page * this.top;
    if (folder) {
      this.checkExpendedFolder(folder);
      if (page > 0) {
        this.setFolder(folder, current);
      } else {
        this.setFolder(folder);
      }
    } else {
      this.refreshData(current);
    }
  }

  checkExpendedFolder(selectedFolder) {
    for (let i = 0; i < this.menuList.length; i++) {
      if (this.menuList[i].directories.length > 0) {
        for (let h = 0; h < this.menuList[i].directories.length; h++) {
          if (this.menuList[i].directories[h].code === selectedFolder) {
            this.menuList[i].expanded = true;
            this.menuList[i].directories[h].checked = true;
          }
          if (this.menuList[i].directories[h].directories.length > 0) {
            for (let j = 0; j < this.menuList[i].directories[h].directories.length; j++) {
              if (this.menuList[i].directories[h].directories[j].code === selectedFolder) {
                this.menuList[i].expanded = true;
                this.menuList[i].directories[h].expanded = true;
                this.menuList[i].directories[h].directories[j].checked = true;
              }
            }
          }
        }
      }
    }
    this.setFolder(selectedFolder);
  }

  resetSessionFilters() {
    this.count = 0;
    sessionStorage.removeItem('savedFilters');
    this.searchTerm = '';
    this.requestFolderUniqueCode = '';

    this.resetDataFilters();
    this.removeTypeFilter(this.count);
    // MENULIST
    this.menuList = [];
    this.requestService.getInitialData(this.isRet).subscribe(
      (data: any) => {
        if (!this.isRet) {
          this.requestFolders = data[1].Result.Collection;
          this.menuList = new RequestFolder().mapFolders(this.requestFolders);
          this.selectRetailer = 'pt.edp.retailer.0';
        } else {
          this.selectRetailer = this.user.retailerUniqueCode;
        }
        this.initStatusData(data[0]);
      },
      (err: any) => {
        console.error(err);
      }
    );
  }

  validationFilter(): void {
    if (
      (this.requestStatusSelected !== null && this.requestStatusSelected !== '') ||
      (this.requestOperationRetSelected !== null && this.requestOperationRetSelected !== '') ||
      (this.requestOperationSelected !== null && this.requestOperationSelected !== '') ||
      (this.requestAreaSelected !== null && this.requestAreaSelected !== '') ||
      (this.requestType1Selected !== null && this.requestType1Selected !== '') ||
      (this.requestType2Selected !== null && this.requestType2Selected !== '') ||
      (this.searchTerm !== null && this.searchTerm !== '') ||
      (this.requestDateForm.get('dateStart').value !== null && this.requestDateForm.get('dateEnd').value !== null)
    ) {
      this.refreshData(0);
    }
  }

  resetFilters(): void {
    this.requestDateForm.reset();
    this.filtersCtrl = false;
    this.showSessionFilters = false;
    this.resetSessionFilters();
  }
}
